import { useMutation } from "@tanstack/react-query";
import AuthService from "@/features/auth/services/auth-service/auth-service";

export const useLogout = () =>
  useMutation({
    mutationKey: ["logout"],
    mutationFn: () => AuthService.logout(),
  });
